import { apiGet, apiPost } from './client';
import type { RobotHeldBy } from '../../utils/robotHold';

/**
 * MKS-241 — Bot Admin held Robot tasks. Both routes sit behind the admin gate.
 */
export interface HeldRobotTask {
  taskId: number;
  code: string | null;
  name: string;
  /** `triager`: a candidate the triager offers once clear. `release`: a human approved it and the 5-minute tick assigns it. */
  waitingFor: 'triager' | 'release';
  approvedAt: string | null;
  heldBy: RobotHeldBy[];
}

export interface RobotHoldOverrideResult {
  taskId: number;
  code: string | null;
  overriddenAt: string;
  released: boolean;
}

export async function getHeldRobotTasks(projectId: number): Promise<HeldRobotTask[]> {
  const res = await apiGet<{ data: HeldRobotTask[] }>(`/admin/bot/routing/${projectId}/held`);
  return res.data;
}

export async function overrideRobotHold(taskId: number): Promise<RobotHoldOverrideResult> {
  const res = await apiPost<{ data: RobotHoldOverrideResult }>(
    `/admin/bot/routing/tasks/${taskId}/hold-override`,
    {}
  );
  return res.data;
}
